import React, {Component} from 'react';
import {Label, ResponsiveContainer, Scatter, ScatterChart, Tooltip, XAxis, YAxis} from "recharts";

import connect from "react-redux/es/connect/connect";

class SpectrumViewer extends Component {

    render() {

        return (
            <ResponsiveContainer width='100%' height={580}>
                <ScatterChart margin={{top: 20, right: 20, bottom: 20, left: 20}}
                              data={this.props.spectrum.peaks}>
                    <XAxis type="number" dataKey='x' name='m/z' domain={[100, 1500]} allowDecimals={false}>
                        <Label value="m/z" offset={0} position="insideBottom"/>
                    </XAxis>
                    <YAxis type="number" dataKey={'y'}
                           label={{value: 'intensity', angle: -90, position: 'insideLeft'}} name='intensity'
                           domain={[0, 'auto']} allowDecimals={false}/>
                    {/*<Brush dataKey='x' height={30} stroke="#8884d8"/>*/}
                    <Tooltip cursor={{strokeDasharray: '3 3'}}/>
                    <Scatter name='A' fill='#8884d8' shape={<SpectrumLine/>}/>
                </ScatterChart>
            </ResponsiveContainer>
        );
    }
}

const getPath = (x, y, height) => (
    `M${x},${y}
   L${x},${height}
   Z`
);

const SpectrumLine = (props) => {
    const {
        fill, x, y
    } = props;

    return <path d={getPath(x, y, 529)} stroke={fill} fill="none"/>;
};

function mapStateToProps(state) {

    return {
        spectrum: state.gsmResultsReducer.spectrum
    }
}

export default connect(mapStateToProps)(SpectrumViewer);